import Layout from '@components/layout/layout-six'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Seo from '@components/seo/seo'
import Divider from '@components/ui/divider'
import { useTranslation } from 'next-i18next'
import OrderForm from '@components/order/order-form'
import BenefitsBar from '@components/common/benefits-bar'
import { useEffect, useState } from 'react'
import { getRelatedCartProducts } from '@framework/typesense'
import { useCart } from '@contexts/cart/cart.context'

export default function TrackOrder({ locale }) {
  const { t: translate } = useTranslation('common')
  const {
    items,
    resetCart,
    isEmpty,
    callShippingInformation,
    setAvailablePaymentMethods,
    setShippingMethods,
    setSelectedShippingMethod,
    groupItems,
  } = useCart()
  const [relatedItems, setRelatedItems] = useState([])
  const [cartItems, setCartItems] = useState([])
  useEffect(() => {
    if (items) {
      setCartItems(items)
    }
  }, [items])

  useEffect(() => {
    if (!cartItems || cartItems.length === 0) return
    const categories: any = Array.from(
      new Set(cartItems.flatMap((product) => product.category)),
    )
    const excludedSkus = cartItems.map((product) => product.sku)

    getRelatedCartProducts(categories, excludedSkus, locale).then((hits: any) =>
      setRelatedItems(hits),
    )
  }, [cartItems, locale])
  return (
    <>
      <Seo
        title="Track Order"
        description={translate('text-home-seo-blurb', { ns: 'common' })}
        path="order-status"
      />
      <Divider />
      <div className="flex items-center justify-center">
        <div className="px-4 pt-16 lg:pt-10 md:px-6 lg:px-8 2xl:px-10 w-full">
          <OrderForm isPopup={false} relatedItems={relatedItems} />
        </div>
      </div>

      <div className="w-full mt-10 lg:mt-0--">
        <BenefitsBar />
      </div>
    </>
  )
}

TrackOrder.Layout = Layout

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, [
        'common',
        'trackorder',
        'categories',
        'forms',
        'menu',
        'home',
        'footer',
      ])),
    },
  }
}
